<template>
  <span>
    <meta
      :itemprop="SCHEMA_ITEM_PROP.RATING_VALUE"
      :content="rating"
    >
    <meta
      :itemprop="SCHEMA_ITEM_PROP.WORST_RATING"
      :content="MIN_POINTS_FOR_RATINGS"
    >
    <meta
      :itemprop="SCHEMA_ITEM_PROP.BEST_RATING"
      :content="MAX_POINTS_FOR_RATINGS"
    >
    <meta
      v-if="reviewsCount"
      :itemprop="SCHEMA_ITEM_PROP.REVIEWS_COUNT"
      :content="reviewsCount"
    >
  </span>
</template>

<script lang="ts">

import { MAX_POINTS_FOR_RATINGS, MIN_POINTS_FOR_RATINGS } from '~~/constants/reviews';
import { SCHEMA_ITEM_TYPE, SCHEMA_ITEM_PROP } from '~~/constants/seo';

export default defineComponent({
  name: 'ReviewMetaSchema',
  props: {
    reviewsCount: {
      type: Number,
      default: null,
    },
    rating: {
      type: Number,
      required: true,
    },
  },
  setup() {

    return {
      SCHEMA_ITEM_TYPE,
      SCHEMA_ITEM_PROP,
      MAX_POINTS_FOR_RATINGS,
      MIN_POINTS_FOR_RATINGS,
    };
  
  },
});

</script>
